<div [formGroup]="form">
	<div class="fees-mode-checkbox">
		<div class="label">Pricing parameters</div>
		<nb-radio-group id="fees-mode" name="fees-mode" [formControlName]="feesModeControlName" status="primary">
			<nb-radio value="PER_YEAR">3-years cycle</nb-radio>
			<nb-radio value="PER_EVENT">per audit event</nb-radio>
		</nb-radio-group>
	</div>

	<div class="direct-price-adjustments">
		@if (showDailyRate | async) {
			<div class="direct-price-adjustment">
				<div class="direct-price-adjustment-label">
					<div class="label">DAILY RATE</div>
					<div class="hint">{{ feesRateHint$ | async }}</div>
				</div>
				<input name="daily-rate" type="number" pattern="-?[0-9]*" (keypress)="preventNonNumericalInput($event)" nbInput fullWidth [placeholder]="'Daily rate'"
					   [formControlName]="dailyRateControlName">
				@if (isInvalid(dailyRateControlName)) {
					<div class="validation-message">{{ getValidationErrors(dailyRateControlName) | async }}</div>
				}
			</div>
		}

		@if (fees$ | async; as fees) {
			@for (fee of fees; track fee.controlName) {
				@if (fee.shouldShow && form.contains(fee.controlName)) {
					<div class="direct-price-adjustment">
						<div class="direct-price-adjustment-label">
							<div class="label">{{ fee.label }}</div>
							<div class="hint">{{ feesRateHint$ | async }}</div>
						</div>
						<input
							type="number"
							pattern="-?[0-9]*"
							(keypress)="preventNonNumericalInput($event)"
							nbInput
							[placeholder]="fee.placeholder"
							[formControlName]="fee.controlName"
							fullWidth
						/>
						@if (isInvalid(fee.controlName)) {
							<div class="validation-message">
								{{ getValidationErrors(fee.controlName) | async }}
							</div>
						}
					</div>
				}
			}
		}
	</div>
</div>
